import {
  Alert as MantineAlert,
  AlertProps as MantineAlertProps,
} from '@mantine/core';
import { FC, ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './styles.module.css';
import cx from 'clsx';

interface AlertProps
  extends Omit<
    MantineAlertProps,
    'color' | 'icon' | 'className' | 'classNames'
  > {
  type: 'info' | 'warning' | 'error';
  children: ReactNode;
}

const alertClassMap = {
  info: styles.alertInfo,
  warning: styles.alertWarning,
  error: styles.alertError,
} as const;

const iconMap = {
  info: 'info',
  warning: 'warning',
  error: 'warning',
} as const;

export const Alert: FC<AlertProps> = ({ type, title, children, ...props }) => {
  return (
    <MantineAlert
      {...props}
      title={title}
      variant="light"
      color="gray"
      icon={<Icon name={iconMap[type]} />}
      className={cx(alertClassMap[type])}
      classNames={{
        root: styles[type],
        title: styles.title,
        message: styles.message,
        icon: styles.icon,
      }}
    >
      {children}
    </MantineAlert>
  );
};
